'use strict';

import useModalProps from '../hooks/useModalProps';
import LandingRequestFormContainer from "../containers/LandingRequestFormContainer";

function LandingRequestFormModal ( props )
{
    const MODES = {form: 'form', success: 'success'}
    
    const { goals, fields: initialFields, data, mode: initialMode, showCheckboxMedia } = useModalProps ( 'reactLandingRequestFormModal', props, { data: {}, mode: MODES.form } );
    const [mode, setMode] = React.useState(MODES.form);
    const [fields, setFields] = React.useState(props.fields) // Сохраняем в стейт, чтобы при открытии модалки форма не моргала
    
    React.useEffect(() => {
        initialFields && setFields(initialFields);
        initialMode in MODES && setMode(initialMode);
    }, [ initialMode, initialFields ])
    
    const handleSuccessSubmit = () => {
        setMode(MODES.success);
        setTimeout(() => {
            setMode(MODES.form);
            $.fancybox.close();
        }, 3000);
    }
    
    return <div className="order-modal">
        <a className="order-modal__close" data-fancybox-close="">{__('barometer.close')}</a>

        {mode === MODES.success && <div className="order-modal__wrapp">
            <div className="success-modal__title">
                <i className="icon-check2"></i>
                <h3>{__('hotels.thanks')}</h3>
                <span dangerouslySetInnerHTML={{__html: __('request.form.success.message')}}/>
            </div>
        </div>}

        {mode === MODES.form && <div className="order-modal__wrapp">
            <div className="order-modal__title">
                <h3>{__('request.form.title')}</h3>
                <span>
                    <span>{data ? data.direction : ''}</span> / <span>{data ? data.dates : ''}</span>
                </span>
            </div>
            <div className="sf-row">
                <LandingRequestFormContainer 
                    landingName={props.landingName}
                    url={props.url}
                    goals={goals || []} 
                    fields={fields || []} 
                    data={data || {}} 
                    useAnimation={false}
                    onSuccessSubmit={handleSuccessSubmit}
                    showCheckboxMedia={showCheckboxMedia}
                />
            </div>
        </div>}
    </div>
}

window.LandingRequestFormModal = LandingRequestFormModal
